import React from "react";

import { WatchVec2 } from "@piqnt/runtime-core/react/WatchValue";
import {
  Pair,
  PairKey,
  PairValue,
  Subtree,
  SubtreeBody,
  SubtreeHeader,
} from "@piqnt/runtime-core/react/Subtree";
import { useMiddleware } from "@piqnt/runtime-core/react/ReactMount";
import { SpaceContext } from "../space";

export const ViewboxView: React.FC = () => {
  const { context, emit } = useMiddleware<SpaceContext>();

  const viewbox = context.draftScene.value?.viewbox;
  const editable = context.editable.value;

  if (!viewbox) return null;

  return (
    <Subtree open>
      <SubtreeHeader>viewbox</SubtreeHeader>
      <SubtreeBody>
        <Pair>
          <PairKey>start</PairKey>
          <PairValue>
            <WatchVec2
              editable={editable}
              getValue={() => viewbox.start}
              setValue={(v) => emit("set-viewbox", { viewbox: { start: v } })}
            />
          </PairValue>
        </Pair>
        <Pair>
          <PairKey>end</PairKey>
          <PairValue>
            <WatchVec2
              editable={editable}
              getValue={() => viewbox.end}
              setValue={(v) => emit("set-viewbox", { viewbox: { end: v } })}
            />
          </PairValue>
        </Pair>
      </SubtreeBody>
    </Subtree>
  );
};
